export default class Locale_AnnouncementViewer { 
	DontShowAgain: string = "Don't show again";
	Announcements: string = "Announcements";
}